import {
  callApi,
  type ApiRequest,
  type ApiResponse,
  deleteAPI,
  type ApiResponseSingle,
  properCallApi
} from '@/api/tenantClient';

export const addressQueryKey = 'registration.addressList';
export const addressQueryKeyBoth = 'registration.addressListBoth';

export interface Address {
  id: number
  address: string
  address2?: string
  suburb: string
  country: string
  state: string
  postCode: string
  companyName?: string
  registrationId?: number
  groupRegistrationId?: number
  userId?: number
  type: 'billing' | 'shipping'
}

export interface AddressQueryRequest {
  id: string
  type: 'billing' | 'shipping'
}

interface BothAddressRequest {
  registrationId?: number
  groupRegistrationId?: number
}

export interface BothAddressResponse {
  billingAddress: Address
  shippingAddress: Address
}

export function loadAddress(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: AddressQueryRequest
  ): Promise<ApiResponse<Address[]>> => {
    request.method = 'GET';
    request.endpoint.path = `/api/v1/addresses/${params.id}`;
    request.endpoint.query = { type: params.type };
    return await callApi<Address[]>(request);
  };
}

export function loadBothAddresses(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: BothAddressRequest
  ): Promise<ApiResponseSingle<BothAddressResponse>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/addresses/show_both';
    request.endpoint.query = params;
    return await properCallApi<ApiResponseSingle<BothAddressResponse>>(request);
  };
}

export interface AddressSaveRequestItem extends Omit<Address, 'id'> {
  id?: number
}

export interface AddressSaveRequest {
  addresses: AddressSaveRequestItem[]
  firstName?: string
  lastName?: string
  registrationId?: number
  groupRegistrationId?: number
}

export function saveAddresses(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: AddressSaveRequest
  ): Promise<ApiResponse<Address[]>> => {
    request.method = 'POST';
    request.payload = {
      addresses: params.addresses,
      firstName: params.firstName,
      lastName: params.lastName,
      registrationId: params.registrationId,
      groupRegistrationId: params.groupRegistrationId,
    };

    if (params.addresses.some(a => { return !!a.id; })) {
      request.endpoint.path = '/api/v1/addresses/update_both';
    } else {
      request.endpoint.path = '/api/v1/addresses/create_both';
    }
    return await callApi<Address[]>(request);
  };
}

export interface AddressDeleteRequest {
  id: number
  type: 'billing' | 'shipping'
}

export function deleteAddress(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (params: AddressDeleteRequest) => {
    request.method = 'DELETE';
    request.endpoint.path = '/api/v1/addresses/' + params.id;
    request.endpoint.query = { type: params.type };
    await deleteAPI(request);
  };
}
